import debounce from 'lodash/debounce';
import ScrollReveal from './animations/ScrollReveal';
import LazyVideos from './components/LazyVideos';
import Header from './components/Header';
import { Sizes } from './types';
import Lenis from 'lenis';
import { gsap } from 'gsap';

import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Flip } from 'gsap/Flip';
import Parallax from './animations/Parallax';
import Counter from './animations/Counter';
import News from './components/News';
import Marquee from './animations/Marquee';
import Accordion from './components/Accordion';
import Swiper from 'swiper';
import { Navigation,Pagination } from 'swiper/modules';
import ResponsiveSwiper from './components/ResponsiveSwiper';
import SmoothScroll from './singleton/SmoothScroll';


gsap.registerPlugin(ScrollTrigger, Flip);

class Website {
  $body: JQuery<HTMLElement>;
  $links: JQuery<HTMLElement>;
  sizes: Sizes;
  header: Header;
  smoothScroll: typeof SmoothScroll;
  responsiveSwipers: JQuery<ResponsiveSwiper>;

  constructor() {
    this.$body = $('body');
    this.sizes = this.getSizes();
    this.$links = $('a');
    this.header = new Header(
      this.sizes,
    );

    // Activate the smooth scrolling feature.
    this.smoothScroll = SmoothScroll

    // this.initScrollingLinks();
    this.initPreloader();

    this.initObservers();
    this.addEventListeners();

    if (this.$body.hasClass('page-template-template-news')) {
      const news = new News();
    }

    $('.accordion').map((_, el) => new Accordion(el));

    this.initBaseSwiper();
    this.initFacts();
    this.initColorShift();
    this.initSteps();
    this.initScrollingLinks();

    this.responsiveSwipers = $('.responsive-swiper').map((_, el) => new ResponsiveSwiper(
      this.sizes,
      el,
      {
        slidesPerView: 'auto',
        speed: 500,
        modules: [Navigation],
        navigation: {
          nextEl: $(el).find('.swiper-button-next')[0],
          prevEl: $(el).find('.swiper-button-prev')[0],
        },
      }
    ));

  }

  initPreloader() {
    const $preLoader = $('.pre-loader');
    const hasPlayed = sessionStorage.getItem('preloaderPlayed');
    if(!$preLoader.length || hasPlayed) return;

    const $svg = $preLoader.find('svg');
    const $paths = $preLoader.find('path');
    const $letter1 = $preLoader.find('#letter-1');
    const $letter2 = $preLoader.find('#letter-2');
    const $letter3 = $preLoader.find('#letter-3');
    const $leftShape = $preLoader.find('#left-shape');
    const $rightShape = $preLoader.find('#right-shape');
    const $arrow = $preLoader.find('#arrow');

    const tl = gsap.timeline({
      ease: 'power2.in',
      onStart: () => {
        $preLoader.show();
        this.smoothScroll.disableScrolling();
      },
    });

    tl.set($svg.get(0)!, {
      rotate: -90,
      scale: 2
    })

    // set all paths to 0
    $paths.each((index, el) => {
      tl.set(el, {
        strokeDasharray: Math.round(el.getTotalLength()),
        strokeDashoffset: Math.round(el.getTotalLength()),
      })
    })

    tl.set($arrow.get(0)!, {
      opacity: 0,
    })

    tl.to([$letter1.get(0)!, $letter2.get(0)!, $letter3.get(0)!], {
      opacity: 1,
      duration: 1,
      strokeDashoffset: 0,
      stagger: {
        each: 0.2,
      },
    })

    tl.addLabel('lettersDone', '+=0.5');

    tl.to($svg.get(0)!, {
      rotate: 0,
      scale: 1,
      duration: 1.2,
      ease: 'power2.inOut',
    }, 'lettersDone')

    tl.to($rightShape.get(0)!, {
      duration: 1,
      strokeDashoffset: 0,
    }, 'lettersDone')

    tl.to($arrow.get(0)!, {
      duration: 0.2,
      opacity: 1,
      strokeDashoffset: 0,
    }, 'lettersDone+=1')

    tl.to($leftShape.get(0)!, {
      opacity: 1,
      duration: 1,
      strokeDashoffset: 0,
    }, 'lettersDone+=0.2')

    tl.to($preLoader, {
      opacity: 0,
      onComplete: () => {
        $preLoader.hide();
        sessionStorage.setItem('preloaderPlayed', 'true');
        this.smoothScroll.enableScrolling();
      }
    }, '+=1')
  }

  initBaseSwiper() {
    const $swipers = $('.base-swiper');
    if(!$swipers.length) return;

    $swipers.each((_, el) => {
      const $cur = $(el);
      const swiper = new Swiper($cur[0], {
        slidesPerView: 'auto',
        modules: [Navigation],
        navigation: {
          nextEl: $cur.find('.swiper-button-next')[0],
          prevEl: $cur.find('.swiper-button-prev')[0],
        },
      })
    })
  }

  initFacts() {
    const $container = $('.facts');
    if(!$container.length) return;

    $container.each((_, el) => {
      const $cur = $(el);
      const $swiper = $cur.find('.facts__swiper');
      const swiper = new Swiper($swiper[0], {
        slidesPerView: 'auto',
        modules: [Pagination],
        centeredSlides: true,
        spaceBetween: 35,
        pagination: {
          el: $cur.find('.swiper-pagination')[0],
        }
      })
      const $tabs = $cur.find('.facts__tabs');
      const $btns = $tabs.find('.facts__tab');

      $btns.on('click', (e) => {
        e.preventDefault
        const $cur = $(e.currentTarget);

        if(!$cur.hasClass('is-active')) {
          $btns.removeClass('is-active');
          $cur.addClass('is-active');
        }
      });

      $btns.on('mouseenter', (e) => {
        e.preventDefault
        const $cur = $(e.currentTarget);

        if(!$cur.hasClass('is-active')) {
          $btns.removeClass('is-active');
          $cur.addClass('is-active');
        }
      })
    })
  }


  initColorShift() {
    const $colorShiftEls = $('[data-color-shift]');
    if (!$colorShiftEls.length) return;

    $colorShiftEls.each((_, el) => {
      const $el = $(el);
      const target = $el.data('target') || 'body';
      const $target = $(target);
      const fromColor = $el.data('from-color') || $target.css('background-color');
      const fromTextColor = $el.data('from-text-color') || $target.css('color');
      const color = $el.data('color-shift') || '';
      const textColor = $el.data('text-color-shift') || '';
      const start = $el.data('start') || 'top 40%';

      const st = ScrollTrigger.create({
        trigger: $el.get(0),
        start: start,
        onEnter: () => {
          if (color) {
            gsap.to(target, {
              backgroundColor: color,
            });
          }
          if (textColor) {
            gsap.to(target, {
              color: textColor,
            });
          }
        },
        onLeaveBack: () => {
          if (color) {
            gsap.to(target, {
              backgroundColor: fromColor,
            });
          }
          if (textColor) {
            gsap.to(target, {
              color: fromTextColor,
            });
          }
        },
      });
    });
  }

  initSteps() {
    const $container = $('.steps-sections');

    if(!$container.length) return;
    const $sections = $container.children('section');

    $sections.each((index, el) => {
      const $section = $(el);
      const $links = $section.find('aside a');
      const $steps = $section.find('li');

      $steps.each((index, el) => {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 30%',
          end: 'bottom 30%',
          onToggle: (props) => {
            if(props.isActive) {
              $links.removeClass('is-active');
              $links.eq(index).addClass('is-active');
            }
          }
        })
      })
    })
  }

    initScrollingLinks() {
    this.$links.on('click', this.linkClicked.bind(this));
    this.scrollOnPageLoad();
  }


  linkClicked(e: JQuery.ClickEvent) {
    const $cur = $(e.currentTarget);
    const href = $cur.attr('href');
    if (!href) return;
    const hrefArr = href.split('#');
    const { pathname, origin } = window.location;

    // If the href is empty or just a hash, or if it's not a hash but the
    // path doesn't match the current page, do nothing.
    if (
      !href ||
      href === '#' ||
      (!href.startsWith('#') && !href.includes('#')) ||
      (!href.startsWith('#') &&
        hrefArr[0] !== pathname &&
        hrefArr[0] !== origin + pathname)
    ) {
      return;
    }

    const $target = href.startsWith('#') ? $(href) : $(`#${hrefArr[1]}`);
    if ($target.length) {
      e.preventDefault();

      // scroll to target
      const offset = $target.offset();
      if (!offset) return;
      const topOffset = offset.top;

      this.smoothScroll.scroll.scrollTo(topOffset, {
        offset: -150,
        duration: 0.5,
      });

      // update url hash
      window.history.pushState(null, '', href);
    }
  }

  scrollOnPageLoad() {
    const { hash } = window.location;
    if (!hash || hash === '#') return;

    const $target = $(hash);
    if (!$target.length) return;

    const offset = $target.offset();
    if (!offset) return;
    const topOffset = offset.top;

    setTimeout(() => {
      this.smoothScroll.scroll.scrollTo(topOffset, {
        offset: -150,
        duration: 0.5,
      });
    }, 200);
  }


  getSizes() {
    const sizes = {
      wWidth: $(window).width()!,
      wHeight: $(window).height()!,
      documentHeight: $(document).height()!,
    };

    this.sizes = sizes;
    return this.sizes;
  }

  initObservers() {
    new ScrollReveal(
      $(
        '[data-visibility]:not([data-is-visible]), [data-visibility-inside]>*:not([data-is-visible])',
      ),
    );
    $('[data-parallax-container').map((_, el) => new Parallax(el));

    new Counter($('[data-reveal-counter]'));
    new LazyVideos();
    $('.marquee').map((_, el) => new Marquee(el));
  }

  addEventListeners() {
    const debouncedResize = debounce(this.onResize.bind(this), 500);
    $(window).on('resize', debouncedResize);
  }

  onResize() {
    this.getSizes();
    if (this.header.onResize) this.header.onResize(this.sizes);
    if(this.responsiveSwipers.length) {
      this.responsiveSwipers.each((_, el) => el.onResize());
    }
  }
}

$(function () {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const website = new Website();
});
